export default [
  { to: 'behandling', title: 'Behandlingsriktlinjer' },
  { to: 'calculator', title: 'Doskalkylator' },
  { to: 'arkiv', title: 'Arkiv' },
  { to: 'slasmed', title: 'SLASmedlemmar' },
];
